var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocateMyDeviceSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,0C9.3828125,0,4,5.3828125,4,12c0,3.8837891,2.9150391,8.6748047,4.1679688,10.5546875l5.4453125,8.1679688 C14.1474609,31.5224609,15.0390625,32,16,32s1.8525391-0.4775391,2.3867188-1.2773438l5.4453125-8.1679688 C25.0849609,20.6748047,28,15.8837891,28,12C28,5.3828125,22.6171875,0,16,0z M22.1679688,21.4453125l-5.4453125,8.1679688 c-0.3222656,0.484375-1.1230469,0.484375-1.4453125,0l-5.4453125-8.1679688C7.4326172,17.8457031,6,14.3154297,6,12 C6,6.4863281,10.4863281,2,16,2s10,4.4863281,10,10C26,14.3154297,24.5673828,17.8457031,22.1679688,21.4453125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,7h-4c-1.1025391,0-2,0.8974609-2,2v8c0,1.1025391,0.8974609,2,2,2h4c1.1025391,0,2-0.8974609,2-2V9 C20,7.8974609,19.1025391,7,18,7z M14,17V9h4l0.0019531,8H14z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocateMyDeviceSmall);
export default __webpack_public_path__ + "static/media/locate-my-device--small.1a1f0d6a71221fd77e1469f6621456cb.svg";
export { ForwardRef as ReactComponent };